import { render, staticRenderFns } from "./config-test.vue?vue&type=template&id=5876c1a0&"
import script from "./config-test.vue?vue&type=script&lang=js&"
export * from "./config-test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports